/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GetCoreConfigResponse
 */
export interface GetCoreConfigResponse {
    /**
     *
     * @type {string}
     * @memberof GetCoreConfigResponse
     */
    uniqueId?: string;
    /**
     *
     * @type {number}
     * @memberof GetCoreConfigResponse
     */
    schemaVersion?: number;
    /**
     *
     * @type {Date}
     * @memberof GetCoreConfigResponse
     */
    createdAt?: Date;
    /**
     *
     * @type {string}
     * @memberof GetCoreConfigResponse
     */
    type?: GetCoreConfigResponseTypeEnum;
    /**
     *
     * @type {string}
     * @memberof GetCoreConfigResponse
     */
    coreConfig?: string;
}

/**
 * @export
 */
export const GetCoreConfigResponseTypeEnum = {
    Shadow: "Shadow",
    Draft: "Draft",
    Published: "Published",
} as const;
export type GetCoreConfigResponseTypeEnum =
    (typeof GetCoreConfigResponseTypeEnum)[keyof typeof GetCoreConfigResponseTypeEnum];

/**
 * Check if a given object implements the GetCoreConfigResponse interface.
 */
export function instanceOfGetCoreConfigResponse(
    value: object,
): value is GetCoreConfigResponse {
    return true;
}

export function GetCoreConfigResponseFromJSON(
    json: any,
): GetCoreConfigResponse {
    return GetCoreConfigResponseFromJSONTyped(json, false);
}

export function GetCoreConfigResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GetCoreConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        uniqueId: json["uniqueId"] == null ? undefined : json["uniqueId"],
        schemaVersion:
            json["schemaVersion"] == null ? undefined : json["schemaVersion"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        type: json["type"] == null ? undefined : json["type"],
        coreConfig: json["coreConfig"] == null ? undefined : json["coreConfig"],
    };
}

export function GetCoreConfigResponseToJSON(
    value?: GetCoreConfigResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        uniqueId: value["uniqueId"],
        schemaVersion: value["schemaVersion"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        type: value["type"],
        coreConfig: value["coreConfig"],
    };
}
